import { Divider } from "@material-ui/core";
import { CSSProperties, FC, ReactNode } from "react";
import "./styles.scss";

interface HeaderFormaPagamentoProperties {
    title: ReactNode,
    subTitle?: ReactNode,
    icon?: ReactNode,
    style?: CSSProperties
}

const HeaderFormaPagamento: FC<HeaderFormaPagamentoProperties> = ({
    title,
    subTitle,
    icon,
    style,
}) => {
    return <div className="HeaderFormaPagamento" style={style}>
        <div className="icon-title-container">
            {icon && <div className="icon">{icon}</div>}
            <div className="title">{title}</div>
        </div>
        {subTitle && <div className="subtitle-container">
            <div className="subtitle">{subTitle}</div>
        </div>}
        <Divider />
    </div>
}

export { HeaderFormaPagamento }